import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,    
    placement: PropTypes.string,    
    target: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.instanceOf(Element),
        PropTypes.shape({ current: PropTypes.any })
    ]).isRequired,
    text: PropTypes.string    
};

const defaultProps = {
    placement: 'top',
    className: '',
    text: 'Try again later'
};

const TryAgainToolTip = ({ target, placement, text, className }) =>
    (<UncontrolledTooltip
        placement={placement}
        autohide={false}
        target={target}
        className={"try-again-tooltip" + (className ? " " + className : "")}
        hideArrow
     >
         {text}
    </UncontrolledTooltip>); 


TryAgainToolTip.propTypes = propTypes;
TryAgainToolTip.defaultProps = defaultProps;

export default TryAgainToolTip;